/**
 * Проверяет и корректирует значение региона
 * Значение должно входить в regions
 */
export const prepareRegion = (region: string | string[], possibleRegions: number[]) => {
  if (!region || !possibleRegions.length) {
    return;
  }

  const regionAsNumber = Number(typeof region === 'string' ? region : region[0]);

  if (!possibleRegions.includes(regionAsNumber)) {
    return;
  }

  return regionAsNumber;
};
